import { mcToast } from '@/plugins/McToastAlertPlugin'

const errorHandlerRest = (e) => {
  let errors = true

  switch (e?.response?.status) {
    case 401:
      // TODO: probably need to adjust this since we are using cookies for auth
      localStorage.removeItem('token')
      localStorage.removeItem('domainName')
      localStorage.removeItem('domainNameExpired')
      localStorage.removeItem('payload')

      window.location.href = '/login'
      break

    case 400:
      if (e.response.data?.message === 'bad_request') {
        mcToast.error('Terdapat kesalahan format pada input anda')
      }

      // So usage will be:
      // const res = await FleetTask.get()
      // if(res.errors) /* do error handling */
      // else /* do something else */

      errors =
        (e.response?.data?.errors ||
          e.response?.data?.message ||
          e.response?.data?.details
            ?.map((detail) => `${detail.field} ${detail.message}`)
            .join(', ')) ??
        errors

      mcToast.error('Bad Request: ' + errors)

      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
        },
      })

    case 403:
    case 404:
      errors = e.response?.data?.errors ?? errors

      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
        },
      })
    case 409:
      errors =
        e.response?.data?.message ??
        e.response?.data?.details?.map((detail) => detail.message).join(', ') ??
        errors

      mcToast.error('Conflict: ' + errors)

      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
        },
      })

    case 500:
      mcToast.error(e.response?.data?.message ?? e.response?.data?.error)
      break

    default:
      console.error(e)
      mcToast.error(
        `${e.response?.status} ${e.response?.data?.message || e.response?.data || e.message}`
      )
  }
}

/*
 * NOTE:
 * errorHandlerRestV2 is created since we need to handle toast message from
 * parent completely, since errorHandlerRest (v1) is used in existing code,
 * removing the toast message will break the existing code.
 */
export const errorHandlerRestV2 = (e) => {
  let errors = true

  switch (e?.response?.status) {
    case 401:
      localStorage.removeItem('token')
      localStorage.removeItem('domainName')
      localStorage.removeItem('domainNameExpired')
      localStorage.removeItem('payload')

      window.location.href = '/login'
      break

    // So usage will be:
    // const res = await FleetTask.get()
    // if(res.errors) /* do error handling */
    // else /* do something else */
    case 400:
    case 403:
    case 404:
    case 422:
      errors = e.response?.data?.errors ?? errors

      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
          message: e.response.data?.message,
        },
      })

    case 500:
      mcToast.error('Internal Server Error')
      break

    default:
      console.error(e)

      mcToast.error(`${e.response?.status} ${e.response?.data || e.message}`)
      return Promise.resolve({
        data: {
          errors: e.response?.data ?? errors,
          status: e.response.status,
        },
      })
  }
}

export default errorHandlerRest
